'use strict';
var React = require('react');
var ReactRedux = require('react-redux');
var ProfileSettingsComponent = require('../../user/settings/profile');
var AddressSettingsComponent = require('../../user/settings/address');
var CreditLineSettingsComponent = require('../../custom-views/user-profile/credit-line');
var StatementComponent = require('../../custom-views/user-profile/statements');

var HeaderLayoutComponent = require('../../../views/layouts/header').HeaderLayoutComponent;
var FooterLayout = require('../../../views/layouts/footer').FooterLayoutComponent;

var addressActions = require('../../../redux/addressActions');
var userActions = require('../../../redux/userActions');

class UserSettingsIndexComponent extends React.Component {
    constructor(props) {
        super(props);
        // console.log(props);
    }

    componentDidMount() {
        const self = this;

        $('#settings-tab a').on('click', function (e, isSkipClickEvent) {
            e.preventDefault();

            let currentActive = $("ul li.active a").attr('href');

            if (currentActive == '#Profile') {
                if (!isSkipClickEvent) {
                    $('.profile-next').trigger('click');
                    return !($('#Profile').find('.error-con').length > 0);
                }
            }
            else if (currentActive == '#Address') {

                $('#addAddress').trigger('click')

                return !(self.props.addresses.length < 1)
            }

            else if (currentActive == '#Payment') {
                let result = !$('.account-not-link .mandatory-payment').length

                if (result == false) {
                    $('.payment-next').trigger('click')
                }

                return result;
            }

            return true
        });


    }

    render() {
    const { user } = this.props;
    // console.log('User Type:', user.CustomFields[5]);
    let userTypeValue = null;

    user.CustomFields.forEach(field => {
        if (field.Code === process.env.CF_TIPO_USUARIO) {
            userTypeValue = field.Values[0];
        }
    });
    const showCreditAndStatements = userTypeValue === 'B2B';
    let states = this.props.uniqueWarehouses;
        return (
            <React.Fragment>
                <div id='settings-index-container'>
                    <div className='header mod' id='header-section'>
                        <HeaderLayoutComponent categories={this.props.categories} user={this.props.user} />
                    </div>
                    <div className='main'>
                        <div className='settings-container'>
                            <div className='container'>
                                <div className='h-parent-child-txt full-width'>
                                    <p><a href='/'>Inicio</a></p>
                                    <i className='fa fa-angle-right' />
                                    <p className='active'>Mi perfil</p>
                                </div>
                                <div className='settings-content'>
                                    <div className='setting-top'> <span className='h-text'>Ajustes de perfil</span>
                                        <div className="setting-tab">
                                            <ul className='nav nav-pills' id='settings-tab'>
                                                <li className='active'><a data-toggle='tab' href='#Profile'>Perfil</a></li>
                                                <li><a data-toggle='tab' href='#Address'>Direcciones</a></li>
                                                {showCreditAndStatements && <li><a data-toggle='tab' href='#Credit'>Línea de crédito</a></li>}
                                                {showCreditAndStatements && <li><a data-toggle='tab' href='#Statements'>Estados de cuenta</a></li>}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='setting-bot'>
                                        <div className='tab-content'>
                                            <ProfileSettingsComponent
                                                componentType={'user'}
                                                customFieldDefinition={this.props.customFieldDefinition}
                                                user={this.props.user}
                                                userLogins={this.props.userLogins}
                                                updateUserInfo={this.props.updateUserInfo}
                                                getLocations={this.props.getLocations}
                                                createCustomFieldDefinition={this.props.createCustomFieldDefinition} />
                                            <AddressSettingsComponent deleteAddress={this.props.deleteAddress}
                                                addresses={this.props.addresses}
                                                user={this.props.user}
                                                createAddress={this.props.createAddress}
                                                updateAddress={this.props.updateAddress}
                                                updateUserToOnboard={this.props.updateUserToOnboard}
                                                uniqueWarehouses={this.props.uniqueWarehouses} 
                                                matriz={this.props.matriz} />
                                            {showCreditAndStatements && (
                                            <CreditLineSettingsComponent 
                                                deleteAddress={this.props.deleteAddress}
                                                addresses={this.props.addresses}
                                                user={this.props.user}
                                                createAddress={this.props.createAddress}
                                                updateUserToOnboard={this.props.updateUserToOnboard} />
                                            )}
                                            {showCreditAndStatements && (
                                            <StatementComponent deleteAddress={this.props.deleteAddress}
                                                addresses={this.props.addresses}
                                                user={this.props.user}
                                                createAddress={this.props.createAddress}
                                                updateUserToOnboard={this.props.updateUserToOnboard}/>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='footer fixed' id='footer-section'>
                    <FooterLayout panels={this.props.panels} />
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.userReducer.user,
        addresses: state.settingsReducer.addresses,
        userLogins: state.settingsReducer.userLogins,
        customFieldDefinition: state.settingsReducer.customFieldDefinition,
        uniqueWarehouses: state.settingsReducer.uniqueWarehouses,
        matriz: state.settingsReducer.matriz
    };
}

function mapDispatchToProps(dispatch) {
    return {
        createAddress: (address) => dispatch(addressActions.createAddress(address)),
        updateAddress: (addressId, address) => dispatch(addressActions.updateAddress(addressId, address)),
        deleteAddress: (addressId) => dispatch(addressActions.deleteAddress(addressId)),
        updateUserInfo: (userInfo, callback) => dispatch(userActions.updateUserInfo(userInfo, callback)),
        updateUserToOnboard: (isOnboarded, hasRedirection) => dispatch(addressActions.updateUserToOnboard(isOnboarded, hasRedirection)),
        getLocations: (callback) => dispatch(userActions.getLocations(callback)),
        createCustomFieldDefinition: (customFieldDefinition) => dispatch(userActions.createCustomFieldDefinition(customFieldDefinition))
    };
}

const SettingsIndex = ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps
)(UserSettingsIndexComponent);

module.exports = {
    SettingsIndex,
    UserSettingsIndexComponent
};
